const collections_oss = {
	key: 'collections.oss',

	fn() {
		return {
			normalizer(data) {
				const res = []

				Object.entries(data).forEach(([osName, versions]) => {
					versions.forEach((version) => {
						const hasVersion = osName !== version
						const label = hasVersion ? `${osName} ${version}` : osName
						const value = hasVersion ? `${osName}_${version}` : osName

						res.push({
							label,
							value,
							id: value,
							osName,
							version,
						})
					})
				})

				return res
			},
		}
	},
}

export { collections_oss as default }
